var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5276 4.20305C26.5276 4.20305 29.2103 3.20748 28.9868 5.6253C28.9123 6.62088 28.2416 10.1054 27.7199 13.8744L25.9315 25.039C25.9315 25.039 25.7825 26.6746 24.4411 26.959C23.0997 27.2435 21.0877 25.9635 20.7151 25.679C20.417 25.4657 15.1261 22.2656 13.2631 20.7011C12.7414 20.2745 12.1453 19.4211 13.3376 18.4255L21.1622 11.3143C22.0564 10.461 22.9507 8.46982 19.2247 10.8876L8.79191 17.6433C8.79191 17.6433 7.59959 18.3544 5.36404 17.7144L0.52022 16.2922C0.52022 16.2922 -1.26826 15.2255 1.78706 14.1588C9.23906 10.8165 18.405 7.40308 26.5276 4.20305Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.f444c34bbe97b919c487f5fd3438cb52.svg";
export { ForwardRef as ReactComponent };